import ActivitiesDelete from './ActivitiesDelete';

export default ActivitiesDelete;
